import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FiMap, 
  FiBarChart2, 
  FiCalendar, 
  FiFileText, 
  FiUsers, 
  FiSettings,
  FiTrendingUp,
  FiPieChart,
  FiTarget,
  FiClock,
  FiLayers,
  FiActivity
} from 'react-icons/fi';

const ProjectToolsComponent = ({ projectId }) => {
  const navigate = useNavigate();

  const handleToolClick = (toolId) => {
    if (toolId === 'mindmap') {
      navigate(`/projects/${projectId}/mind-map`);
    }
    if (toolId === 'files') {
      navigate(`/projects/${projectId}/files`);
    }
    if (toolId === 'team') {
      navigate(`/projects/${projectId}/team`);
    }
    if (toolId === 'kanban') {
      navigate(`/projects/${projectId}/kanban`);
    }
    if (toolId === 'tasks') {
      navigate(`/projects/${projectId}/tasks`);
    }
    if (toolId === 'routines') {
      navigate(`/projects/${projectId}/routines`);
    }
    if (toolId === 'reminder') {
      navigate(`/projects/${projectId}/reminders`);
    }
    if (toolId === 'gantt') {
      navigate(`/projects/${projectId}/gantt`);
    }
    if (toolId === 'analytics') {
      navigate(`/projects/${projectId}/analytics`);
    }
    // Diğer araçlar için gelecekte eklenebilir
  };
  const tools = [
    {
      id: 'mindmap',
      name: 'Mind Map',
      icon: FiMap,
      color: 'from-purple-400 to-pink-500',
      hoverColor: 'hover:border-blue-300 dark:hover:border-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20',
      textColor: 'group-hover:text-blue-600 dark:group-hover:text-blue-400'
    },
    {
      id: 'gantt',
      name: 'Gantt',
      icon: FiBarChart2,
      color: 'from-green-400 to-emerald-500',
      hoverColor: 'hover:border-green-300 dark:hover:border-green-600 hover:bg-green-50 dark:hover:bg-green-900/20',
      textColor: 'group-hover:text-green-600 dark:group-hover:text-green-400'
    },
    {
      id: 'reminder',
      name: 'Hatırlatıcı',
      icon: FiCalendar,
      color: 'from-orange-400 to-red-500',
      hoverColor: 'hover:border-orange-300 dark:hover:border-orange-600 hover:bg-orange-50 dark:hover:bg-orange-900/20',
      textColor: 'group-hover:text-orange-600 dark:group-hover:text-orange-400'
    },
    {
      id: 'files',
      name: 'Dosyalar',
      icon: FiFileText,
      color: 'from-indigo-400 to-purple-500',
      hoverColor: 'hover:border-indigo-300 dark:hover:border-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-900/20',
      textColor: 'group-hover:text-indigo-600 dark:group-hover:text-indigo-400'
    },
    {
      id: 'team',
      name: 'Ekip',
      icon: FiUsers,
      color: 'from-cyan-400 to-blue-500',
      hoverColor: 'hover:border-cyan-300 dark:hover:border-cyan-600 hover:bg-cyan-50 dark:hover:bg-cyan-900/20',
      textColor: 'group-hover:text-cyan-600 dark:group-hover:text-cyan-400'
    },
    {
      id: 'analytics',
      name: 'Analitik',
      icon: FiTrendingUp,
      color: 'from-pink-400 to-rose-500',
      hoverColor: 'hover:border-pink-300 dark:hover:border-pink-600 hover:bg-pink-50 dark:hover:bg-pink-900/20',
      textColor: 'group-hover:text-pink-600 dark:group-hover:text-pink-400'
    },
    {
      id: 'routines',
      name: 'Rutinler',
      icon: FiPieChart,
      color: 'from-yellow-400 to-orange-500',
      hoverColor: 'hover:border-yellow-300 dark:hover:border-yellow-600 hover:bg-yellow-50 dark:hover:bg-yellow-900/20',
      textColor: 'group-hover:text-yellow-600 dark:group-hover:text-yellow-400'
    },
    {
      id: 'tasks',
      name: 'Görevler',
      icon: FiTarget,
      color: 'from-teal-400 to-green-500',
      hoverColor: 'hover:border-teal-300 dark:hover:border-teal-600 hover:bg-teal-50 dark:hover:bg-teal-900/20',
      textColor: 'group-hover:text-teal-600 dark:group-hover:text-teal-400'
    },
    {
      id: 'time',
      name: 'Süreç',
      icon: FiClock,
      color: 'from-violet-400 to-purple-500',
      hoverColor: 'hover:border-violet-300 dark:hover:border-violet-600 hover:bg-violet-50 dark:hover:bg-violet-900/20',
      textColor: 'group-hover:text-violet-600 dark:group-hover:text-violet-400'
    },
    {
      id: 'kanban',
      name: 'Kanban',
      icon: FiLayers,
      color: 'from-slate-400 to-gray-500',
      hoverColor: 'hover:border-slate-300 dark:hover:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-900/20',
      textColor: 'group-hover:text-slate-600 dark:group-hover:text-slate-400'
    },
    {
      id: 'activity',
      name: 'Aktivite',
      icon: FiActivity,
      color: 'from-emerald-400 to-teal-500',
      hoverColor: 'hover:border-emerald-300 dark:hover:border-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/20',
      textColor: 'group-hover:text-emerald-600 dark:group-hover:text-emerald-400'
    },
    {
      id: 'settings',
      name: 'Ayarlar',
      icon: FiSettings,
      color: 'from-gray-400 to-slate-500',
      hoverColor: 'hover:border-gray-300 dark:hover:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-900/20',
      textColor: 'group-hover:text-gray-600 dark:group-hover:text-gray-400'
    }
  ];

  return (
    <div className="bg-white dark:bg-dark-300 rounded-md shadow-sm border border-gray-200 dark:border-dark-300 p-6 mb-3">
      <h3 className="text-red-600  dark:text-[#797BF2] text-[12px] font-semibold mb-4">PROJE ARAÇLARI</h3>
      <div className="grid grid-cols-2 gap-3 max-h-[550px] overflow-y-auto">
        {tools.map((tool) => {
          const IconComponent = tool.icon;
          return (
            <div 
              key={tool.id}
              onClick={() => handleToolClick(tool.id)}
              className={`group cursor-pointer p-3 rounded-lg border border-gray-200 dark:border-dark-300 ${tool.hoverColor} transition-all duration-200`}
            >
              <div className="flex flex-col items-center text-center">
                <div className={`w-10 h-10 bg-gradient-to-br ${tool.color} rounded-lg flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-200`}>
                  <IconComponent className="w-5 h-5 text-white" />
                </div>
                <span className={`text-xs font-medium text-gray-700 dark:text-gray-300 ${tool.textColor}`}>
                  {tool.name}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectToolsComponent;
